import { gql } from 'apollo-boost';


export const GET_SELECTED_MAIN = gql`
    query getSelectedMain {
        selectedMain {
            uid
            type
            date
            title
            cover {
                type
                filename
                url
            }
            end {
                category
            }
        }
    } 
`;
